import { LinearProgress } from "@material-ui/core";
import React from "react";
import { Container } from "react-bootstrap";

function CustomContainer({
  children,
  headerLoading = false,
  paddingHorizontal = true,
  backgroundColor,
  className,
}) {
  return (
    <>
      {headerLoading && <LinearProgress />}
      <div
        className={`premium-section ${className}`}
        style={{ backgroundColor }}>
        <Container>
          <div className={paddingHorizontal ? "px-lg-8 mx-lg-4 px-md-3" : ""}>
            {children}
          </div>
        </Container>
      </div>
    </>
  );
}

export default CustomContainer;
